/**
 * Enum Trạng thái database
 * ndhieu3 19.06.2023
 */
export default {
  // Đang làm việc
  Working: 1,
  // Dữ liệu lỗi
  DataError: 2,
  // Không làm việc
  NotWorking: 3,
  // tạo dữ liệu convert
  CreateData: 5,
  // đang convert
  Converting: 6,
  // đang convert
  ConvertError: 7,
  // Đang tạo dữ liệu
  CreatingData: 28,
  // Hoàn thành tạo dữ liệu
  EndCreateData: 19,
};
